import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight, Clock } from "lucide-react";
import { FadeUp } from "@/components/Motion";
import { buildMeta, buildLinks, breadcrumbSchema } from "@/lib/seo";
import { POSTS as BLOG_POSTS } from "@/lib/blog-data";

const POSTS = Object.values(BLOG_POSTS);

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: buildMeta({
      title: "Blog de Podologia em Belém do Pará | Podomasso",
      description:
        "Conteúdo especializado em podologia: cuidados com os pés, prevenção, tratamentos e orientações da Clínica Podomasso, em Belém do Pará.",
      path: "/blog",
    }),
    links: buildLinks("/blog"),
    scripts: [
      breadcrumbSchema([
        { name: "Início", path: "/" },
        { name: "Blog", path: "/blog" },
      ]),
    ],
  }),
  component: BlogPage,
});

function BlogPage() {
  return (
    <>
      <section className="bg-gradient-soft py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeUp>
            <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-primary">
              Conteúdo Educativo
            </p>
            <h1 className="font-display text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">
              Blog da <span className="text-gradient-hero">Podomasso</span>
            </h1>
            <p className="mt-5 max-w-2xl text-lg text-muted-foreground">
              Informação especializada em podologia para cuidar melhor dos seus pés em Belém do
              Pará.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="bg-background py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {POSTS.map((p, i) => (
              <FadeUp key={p.slug} delay={i * 0.08}>
                <Link
                  to="/blog/$slug"
                  params={{ slug: p.slug }}
                  className="group block h-full overflow-hidden rounded-3xl bg-gradient-card shadow-card transition-spring hover:-translate-y-1 hover:shadow-elegant"
                >
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img
                      src={p.image}
                      alt={p.alt}
                      loading="lazy"
                      width={1600}
                      height={1000}
                      className="h-full w-full object-cover transition-spring group-hover:scale-110"
                    />
                  </div>
                  <div className="p-6">
                    <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-primary">
                      {p.category}
                    </p>
                    <h2 className="font-display text-xl font-bold leading-snug transition-smooth group-hover:text-primary">
                      {p.title}
                    </h2>
                    <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                      {p.excerpt}
                    </p>
                    <div className="mt-5 flex items-center justify-between">
                      <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
                        <Clock className="h-3.5 w-3.5" /> {p.readTime}
                      </span>
                      <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary">
                        Ler artigo <ArrowRight className="h-4 w-4" />
                      </span>
                    </div>
                  </div>
                </Link>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
